module.exports = __webpack_public_path__ + "static/media/blog8_2.848e35f0.webp";